import {getContrastColor} from '../../../../composables/useBGColor'

// The shared ColorPicker accepts and emits comma-separated RGBA channels.
// Keep CSS values and picker values explicit so opacity survives reopening.
export const buttonColor = (value: unknown) => {
  let channels = [13, 135, 239, 1]
  if (typeof value === 'string') {
    const hex = value.trim().match(/^#([\da-f]{3}|[\da-f]{6}|[\da-f]{8})$/i)?.[1]
    if (hex) {
      const expanded = hex.length === 3 ? [...hex].map(char => char + char).join('') : hex
      channels = [0, 2, 4].map(offset => parseInt(expanded.slice(offset, offset + 2), 16))
      channels.push(expanded.length === 8 ? parseInt(expanded.slice(6, 8), 16) / 255 : 1)
    } else {
      const parts = value.trim().replace(/^rgba?\(/i, '').replace(/\)$/, '').split(',').map(part => part.trim())
      const numbers = parts.map(Number)
      if ((parts.length === 3 || parts.length === 4) && parts.every(part => part !== '')
        && numbers.every(Number.isFinite) && numbers.slice(0, 3).every(number => number >= 0 && number <= 255)
        && (numbers.length === 3 || (numbers[3] >= 0 && numbers[3] <= 1))) {
        channels = [...numbers.slice(0, 3), numbers[3] ?? 1]
      }
    }
  }
  const picker = channels.join(', ')
  return {picker, css: `rgba(${picker})`, textColor: getContrastColor(channels[0], channels[1], channels[2], channels[3])}
}
